module.exports = {
  width: '1.5rem',
  height: '0.875rem',
  padding: '0.125rem 0',
  background: {
    color: {
      inactive: 'palette.secondaryAlt',
      active: 'palette.primary',
      disabled: 'palette.secondary',
      error: 'palette.error',
    },
  },
  focus: {
    boxShadow: {
      sizes: '0px 0px 0px 3px',
      baseColor: 'palette.primary',
    },
  },
  border: {
    radius: 'radius.xl',
  },
  Pill: {
    width: '0.625rem',
    height: '0.625rem',
    position: {
      inactive: '0.125rem',
      active: 'spacing.sm',
    },
    background: {
      color: {
        inactive: 'palette.surface',
        active: 'palette.surface',
        disabled: 'palette.secondaryAlt',
        error: 'palette.surfaceAlt',
      },
    },
  },
};
